import { Navigate, Outlet } from 'react-router-dom';
export default function PrivateRoute() {
  const token = localStorage.getItem('jwt');
  // 如果没有 token，则跳转到 /login
  if (!token) {
    return <Navigate to="/login" replace />;
  }
  // 已登录：渲染后续子路由
  return <Outlet />;
}
